import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: "Sam's Disposal has been servicing our home for years. They're always on time, professional, and their rates are fair. It's nice to support a local family business that truly cares about the community.",
  author: 'M.J.',
  location: 'Big Rapids'
}, {
  text: "We switched to Sam's after dealing with a national company's poor service and hidden fees. Best decision we made! Simple pricing, friendly drivers, and they actually answer the phone when you call.",
  author: 'R.T.',
  location: 'Reed City'
}, {
  text: "I use their budget bag service and it's perfect for my needs. No contracts, no hassle—just honest service from good people. Highly recommend Sam's Disposal to anyone in the area.",
  author: 'L.K.',
  location: 'Stanwood'
}];
export function Testimonials() {
  return <section className="py-20 bg-gray-50" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-185">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-186">
            What Our Customers Say
          </h2>
        </div>
        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-187">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow" data-id="element-188">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-189">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#E41C1C] text-[#E41C1C]" data-id="element-190" />)}
              </div>
              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed mb-6 italic" data-id="element-191">
                "{testimonial.text}"
              </p>
              {/* Author */}
              <div className="border-t pt-4" data-id="element-192">
                <p className="font-bold text-gray-900" data-id="element-193">{testimonial.author}</p>
                <p className="text-sm text-gray-600" data-id="element-194">{testimonial.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}